export const SettingsSection = {
	AccountBusinessDetails: 'account/business-details',
	AccountBankAccount: 'account/bank-account',
	AccountTeam: 'account/team',
	ProductsSales: 'products/website',
	ProductsWebsite: 'products/website-page',
	ProductsAiBdc: 'products/ai-bdc',
	SharedIntegrations: 'shared/integrations',
	SharedInventory: 'shared/inventory',
} as const;
export type SettingsSection = (typeof SettingsSection)[keyof typeof SettingsSection];
